<template>
  <div>
   
    <!--        Case 1: Topic enrolled-->
    
    <CCard
      class="defaultCard mr-2"
      @mouseover="data.active= true"
      @mouseleave="data.active= false"
      v-if="data.status === true"
    >
      <CCardHeader class="defaultHeaderCard">
        <CRow>
          <CCol class="text-left ml-auto" xl="9">
            <p class="titleText">{{$helpers.translate(courseDetail.topic.name , 'th') }}</p>
          </CCol>
          <CCol class="pt-4" xl="3">
            <div v-if="isComplete">
              <img src="@/assets/icons/completed.svg" width="27   px" height="27px" />
            </div>
            <div
              v-else
              style="background-color: #999999;width: 30px;height: 30px;border-radius: 50%"
            ></div>
          </CCol>
        </CRow>
      </CCardHeader>

      <CCardBody class="column p-0">
        <div class="card-body pt-0 pb-0">
         
          <div>
            <CRow>
              <CCol
                sm="12"
                v-c-tooltip="$helpers.translate(courseDetail.topic.subName , 'th') "
                class="text-left font-weight-bolder fullName truncateCourseName"
                style="color: #999999"
              >{{$helpers.translate(courseDetail.topic.subName , 'th') }}</CCol>
            </CRow>

            <CRow class="mt-2">
              <CCol sm="4" class="text-left description" style="color: #999999">Score</CCol>
              <CCol sm="8" class="text-right description" style="color: #999999">00/000</CCol>
            </CRow>
            <CRow>
              <CCol md="8" sm="5" class="text-left description" style="color: #999999">Active Hour</CCol>
              <CCol md="4" sm="7" class="text-right truncateCatefory" style="color: #999999">00</CCol>
            </CRow>
            <br />
          </div>
        </div>

       
        <CRow class="card-body pt-0" @click="navigateOverview(data.navigate)">
          <CCol v-if="courseDetail.topic.topicUsers[0].progress == 0" sm="12">
            <CButton block class="border-0 button-overview-notActive">NO PROGRESS</CButton>
          </CCol>
          <CCol v-else-if="courseDetail.topic.topicUsers[0].progress==100" sm="12">
            <CButton block class="border-0 button-overview">COMPLETED</CButton>
          </CCol>
          <CCol v-else @click="onclickProgressBarButton('progressbar')">
            <CProgress
              class="progress-bar"
              showPercentage
              :value="courseDetail.topic.topicUsers[0].progress"
              :max="100"
              show-value
              border-radius="50px"
            >
              <CProgressBar style="border-radius:20px; background-color: #62ce62"></CProgressBar>
            </CProgress>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    courseDetail: Object,
  },
  data() {
    return {
      isComplete: true,
      lang: "th",
    };
  },
  created() {
    
    this.isComplete = this.courseDetail.topic.topicUsers[0].complete;
  },
  methods: {
    navigateOverview(nav) {
      //alert(`ยังไม่ได้ทำ`);
    },
  },
  watch: {
    courseDetail: function () {
    },
  },
};
</script>

<style scoped>
.defaultCard {
  position: relative;
  max-height: 100%;
  width: 210px;
  border-radius: 30px;
  background-color: #4d4d4d;
}

.defaultCard:hover {
  /*background-color: red;*/
  cursor: pointer;
}

.defaultHeaderCard {
  padding: 0rem 1.25rem;
  border: 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: transparent;
}

.defaultHeaderCard .titleText {
  font-size: 36px;
  font-weight: bold;
  color: #999999;
  margin-bottom: 0;
  margin-top: 0.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-body {
  -ms-flex: 1 1 auto;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  min-height: 1px;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.description {
  font-size: 14px;
}

.button-overview {
  color: white;
  background-color: #62ce62;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 1px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}
.button-overview-notActive {
  color: #4d4d4d;
  background-color: #999999;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 1px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.progress-bar {
  width: 100%;
  height: 100%;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
  background: white;
}

.truncateCourseName {
  width: 5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;

  font-size: 1.12rem;
  margin-bottom: 0.1rem;
  /*allow user to add more space for word*/
  /*resize: horizontal;*/
}

.truncateCatefory {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 0.9rem;
  /*allow user to add more space for word*/
  /*resize: horizontal;*/
}
</style>

